import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCellExport from './cell-export.reducer';

export const selectCellExportState = createFeatureSelector<fromCellExport.CellExportFeatureState>(
  fromCellExport.cellExportFeatureKey
);

export const isExporting = createSelector(selectCellExportState, (state) => state.exportingCellToken !== null);

export const exportingCellToken = createSelector(selectCellExportState, (state) => state.exportingCellToken);

export const isExportingByCellToken = (cellToken: string) =>
  createSelector(selectCellExportState, (state) => state.exportingCellToken === cellToken);

export const progressToastId = createSelector(selectCellExportState, (state) => state.inProgressToastId);
